const TELEGRAM_INTEGRATION_FIELDS = `
  __typename
  ... on TelegramTournamentIntegration {
    id
    status
    chatId
    channelUsername
    channelUrl
    lastPublishedAt
  }
`;

export const TELEGRAM_BOT_INFO_QUERY = `#graphql
  query telegramBotInfo {
    telegramBotInfo {
      username
      addToChannelUrl
    }
  }
`;

export const TOURNAMENT_INTEGRATIONS_QUERY = `#graphql
  query tournamentIntegrations($tournamentId: Int!) {
    tournamentIntegrations(tournamentId: $tournamentId) {
      ${TELEGRAM_INTEGRATION_FIELDS}
    }
  }
`;

export const CREATE_TOURNAMENT_INTEGRATION_MUTATION = `#graphql
  mutation createTournamentIntegration($input: CreateTournamentIntegrationInput!) {
    createTournamentIntegration(input: $input) {
      ${TELEGRAM_INTEGRATION_FIELDS}
    }
  }
`;

export const DELETE_TOURNAMENT_INTEGRATION_MUTATION = `#graphql
  mutation deleteTournamentIntegration($id: Int!) {
    deleteTournamentIntegration(id: $id) {
      status
    }
  }
`;
